<template>
	<!-- 弹窗 -->
	<el-dialog :title="newTitle" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
		<!-- 打分 -->
		<div class="dialogList">
			<p class="normalList_p">{{detail.suggest_content}}</p>
		</div>
		
		<!-- <span slot="footer" class="dialog-footer" style="justify-content: center;display: flex;">
			<el-button @click="">取 消</el-button>
			<el-button type="primary" @click="">确 定</el-button>
		</span> -->
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				newTitle:'',
				detail:{}
			}
		},
		components: {
			
		},
		methods: {
			showDetail(detail) {
				this.dialogVisible = true
				this.detail = detail
				if(detail.feedback_time){
					this.newTitle = `修改意见 时间：${detail.feedback_time}`
				}else{
					this.newTitle = `修改意见`
				}
			},
			handleClose() {
				this.dialogVisible = false
			},
			
		}
	}
</script>

<style scoped="scoped">
	.el-dialog__header {
		height: 100px;
		line-height: 100px;
	}

	>>>.el-dialog__body {
		padding: 10px 20px;
	}
	>>>.el-dialog{
		border-radius: 6px;
	}

	/* 评分弹窗 */
	.dialogList{
		display: flex;
		flex-flow: column;
		align-items: flex-start;
	}
	.normalList_p{
		line-height: 25px;
		padding: 10px;
		text-align: left;
	}
	.specilList_p{
		margin: 10px 0;
		line-height: 25px;
		text-indent: 2em;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FA6400;
	}
	.recommendTip{
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		color: #333333;
	}
</style>
